module.exports = __webpack_public_path__ + "media/images/logo/favicon-32x32-73223822d7cfc6cfc01b2c9457b46e82.png";